import React from "react";
import './MarketsFilterBar.style.scss';
import {FormattedMessage} from "react-intl";
import SideScroller from "../SideScroller/SideScroller";
const MarketsFilterBar = ({vm}) => {

    if(!vm.filteredStatsKeysBySport)
        return null;

    return <div className="MarketsFilterBar">
        <SideScroller>
        {Object.entries(vm.filteredStatsKeysBySport)
               .map(([sportId, statsKeys]) =>
                   <div key={sportId}
                        className="marketFilter">
                        <div className="statsKeys">
                            {statsKeys.map((key, index) => (
                                <button key={index}
                                        type="button"
                                        className={`button ${vm.filters.market === key ? 'active' : ''}`}
                                        onClick={() => vm.handleFilterChange("market", vm.filters.market === key ? null : key)}
                                >
                                    <FormattedMessage id={"StatsKeys."+sportId+"."+key+".lineValueUnit"} />
                                </button>
                            ))}
                        </div>
                   </div>)}
        </SideScroller>
    </div>;
};
export default MarketsFilterBar;